// extracted by mini-css-extract-plugin
module.exports = {"imageUpload":"ImageUpload_imageUpload__1fYBB","nl":"ImageUpload_nl__CTrII","en":"ImageUpload_en__yMAip","de":"ImageUpload_de__1SP7a","da":"ImageUpload_da__1LeLw"};